import ziggyRoute from '../../../vendor/tightenco/ziggy/src/js/index.js'
import Router from '../../../vendor/tightenco/ziggy/src/js/Router'
import { usePage } from '@inertiajs/vue3'

export function route (name, params, absolute, config) {
    // We append the current tenant id to all URLs generated in the backend.
    // An already existing tenant parameter has precedence over the current tenant.
    // We do the same in the backend in the RouteUrlGenerator.
    let parsedParams = params
    const page = usePage()

    if (page.props.tenantSettings.id) {
        // Using ziggy's router to do the parameter parsing, which emulates the laravel router.
        const router = new Router(name, params, absolute, config)
        parsedParams = router._params || {}

        if (!parsedParams.tenant) {
            parsedParams.tenant = page.props.tenantSettings.id
        }
    }

    return ziggyRoute(name, parsedParams, absolute, config)
}
